export const payoutDetailsViewParam = 'view';
const v2View = 'v2';

export const payoutDetailsV2Search = { [payoutDetailsViewParam]: v2View };

export const isPayoutDetailsV2View = (searchParams: URLSearchParams) =>
  searchParams.get(payoutDetailsViewParam) === v2View;
